module.exports = __webpack_public_path__ + "static/media/Diabetes.75a4fa99.svg";